

module.exports = function (input, options) {
  var processor = {
    pipe: function pipe(func) {
      input = func(input, options);
      return processor;
    },
    end: function end() {
      return input;
    }
  };

  return processor;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/idyll-compiler/dist/es/processors/index.js
// module id = 669
// module chunks = 0